import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Lookup,
  MasterDetail,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  reasonLListOfCareer,
  recogExp,
  recogExpList,
  saUnitList,
} from "./data";
import { updateJobDescr } from "./Redux/jobDescr";
import JobDescriptionHtmlEditor from "./JobDescriptionHtmlEditor";
import TwoDateCheckBoxComponent from "./TwoDateCheckBoxComponent";

export default function Career() {
  const [dataSource, setDataSource] = useState(null);
  const [formDataSource, setFormDataSource] = useState(null);
  const [reasonLDataSource, setReasonLDataSource] = useState(
    new DataSource({
      store: reasonLListOfCareer,
      type: "array",
      key: "id",
    })
  );

  const userInfo = useSelector((state) => state.userInfo);

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const psRef = useRef(null);
  const jobDescrRef = useRef(null);
  const careerGridRef = useRef(null);

  const dispatch = useDispatch();

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/career/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          values = {
            ...values,
            otrReasonL:
              values.reasonL == "9"
                ? reasonLDataSource.items().find((item) => item.id == "9").name
                : null,
            startDate: startDateRef.current.instance.option("value"),
            endDate: endDateRef.current.instance.option("value"),
            ps: psRef.current.instance.option("value") == true ? "1" : "0",
            jobDescr: jobDescrRef.current.instance.option("value"),
          };

          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/career/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          values = {
            ...values,
            otrReasonL:
              values.reasonL == "9"
                ? reasonLDataSource.items().find((item) => item.id == "9").name
                : null,
            startDate: startDateRef.current.instance.option("value"),
            endDate: endDateRef.current.instance.option("value"),
            ps: psRef.current.instance.option("value") == true ? "1" : "0",
            jobDescr: jobDescrRef.current.instance.option("value"),
          };

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/career/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/his/career/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );
  }, []);

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    const newReasonL = {
      id: "9",
      name: args.text,
    };

    args.customItem = reasonLDataSource
      .store()
      .insert(newReasonL)
      .then(() => reasonLDataSource.load())
      .then(() => newReasonL)
      .catch((error) => {
        throw error;
      });
  };

  const calculateCellValue = (data) => {
    if (data.ps == "1") {
      return "재직중";
    } else {
      return "퇴사";
    }
  };

  const calculateRecogExpCellValue = (data) => {
    return recogExp[data.recogExp];
  };

  function render(props) {
    const { jobDescr } = props.data;

    return (
      <div>
        <table>
          <tbody>
            <tr>
              {/* <th>담당업무: </th> */}
              <th>Responsibilities: </th>
              {/* <td>{jobDescr}</td> */}
              <td
                dangerouslySetInnerHTML={{
                  __html: jobDescr,
                }}
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  const onEditingStart = (e) => {
    setFormDataSource(null);

    if (e.data.startDate) {
      setFormDataSource((prevState) => ({
        ...prevState,
        startDate: e.data.startDate,
      }));
    }

    if (e.data.endDate) {
      setFormDataSource((prevState) => ({
        ...prevState,
        endDate: e.data.endDate,
      }));
    }

    if (e.data.ps) {
      setFormDataSource((prevState) => ({
        ...prevState,
        ps: e.data.ps,
      }));
    }

    if (e.data.jobDescr) {
      dispatch(updateJobDescr(e.data.jobDescr));
    }

    // if (jobDescrRef.current && e.data.jobDescr) {
    //   jobDescrRef.current.instance.option("defaultValue", e.data.jobDescr);
    //   // console.debug("jobDescr", jobDescrRef.current.instance.option("value"));

    //   jobDescrRef.current.instance.reset();
    // }
  };

  const onInitNewRow = (e) => {
    // e.data.ps = false;
    const key = careerGridRef.current.instance.getKeyByRowIndex(0);

    if (key) {
      e.component.selectRows(key, true);
      e.data = careerGridRef.current.instance.getSelectedRowsData()[0];

      if (e.data.startDate) {
        setFormDataSource((prevState) => ({
          ...prevState,
          startDate: e.data.startDate,
        }));
      }

      if (e.data.endDate) {
        setFormDataSource((prevState) => ({
          ...prevState,
          endDate: e.data.endDate,
        }));
      }

      if (e.data.ps) {
        setFormDataSource((prevState) => ({
          ...prevState,
          ps: e.data.ps,
        }));
      }

      dispatch(updateJobDescr(null));

      // if (e.data.jobDescr) {
      //   console.debug("e.data.jobDescr", e.data.jobDescr);

      //   dispatch(updateJobDescr(e.data.jobDescr));
      // }
    }
  };

  return (
    <DataGrid
      id="careerGrid"
      ref={careerGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",}
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
      onEditingStart={onEditingStart}
      onInitNewRow={onInitNewRow}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Career"}
          confirmDeleteMessage="Are you sure you want to delete this career?"
        />
        <Popup title={"Career"} showTitle={true} height={"auto"} />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="career"
          height={"100%"}
        >
          <SimpleItem
            dataField={"coName"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"회사명"} />
            <RequiredRule message={"* 회사명을 입력해주세요."} />
          </SimpleItem>
          <SimpleItem
            dataField={"div"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            {/* <Label text={"부서"} /> */}
            <Label text={"Department"} />
            {/* <RequiredRule message={"* 부서를 입력해주세요."} /> */}
            <RequiredRule message={"* Department is required."} />
          </SimpleItem>
          <SimpleItem
            dataField={"jobTitle"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            {/* <Label text={"직위(직책)"} /> */}
            <Label text={"Position"} />
            {/* <RequiredRule message={"* 직위(직책)을 입력해주세요."} /> */}
            <RequiredRule message={"* Position is required."} />
          </SimpleItem>
          <SimpleItem>
            <Label text={"재직기간"} />
            <TwoDateCheckBoxComponent
              firstDateBox={{
                // placeholder: "입사일",
                placeholder: "Employment Date",
                field: "startDate",
                ref: startDateRef,
              }}
              secondDateBox={{
                // placeholder: "퇴사일",
                placeholder: "Resignation Date",
                field: "endDate",
                ref: endDateRef,
              }}
              checkBox={{
                field: "ps",
                text: "재직중",
                ref: psRef,
              }}
              formDataSource={formDataSource}
            />
          </SimpleItem>
          <SimpleItem
            dataField={"sa"}
            editorType="dxNumberBox"
            editorOptions={{
              showClearButton: true,
              format: "#,##0",
            }}
          >
            <Label text={"연봉"} />
          </SimpleItem>
          <SimpleItem
            dataField={"saUnit"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: saUnitList,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
            }}
          >
            <Label text={"연봉단위"} />
          </SimpleItem>
          <SimpleItem
            dataField={"recogExp"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: recogExpList,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
            }}
          >
            <Label text={"인정경력여부"} />
          </SimpleItem>
          <SimpleItem
            dataField={"reasonL"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: reasonLDataSource,
              valueExpr: "id",
              displayExpr: "name",
              showClearButton: true,
              placeholder: "직접입력가능",
              acceptCustomValue: true,
              onCustomItemCreating: onCustomItemCreating,
            }}
          >
            {/* <Label text="퇴사사유" /> */}
            <Label text="Reason for Resignation" />
          </SimpleItem>
          <SimpleItem dataField={"jobDescr"} colSpan={4}>
            {/* <Label text={"담당업무"} /> */}
            <Label text={"Responsibilities"} />
            <JobDescriptionHtmlEditor jobDescrRef={jobDescrRef} />
          </SimpleItem>
        </Form>
      </Editing>

      <MasterDetail enabled={true} render={render} />

      <Column dataField={"coName"} caption="회사명" />
      {/* <Column dataField={"div"} caption="부서" /> */}
      <Column dataField={"div"} caption="Department" />
      {/* <Column dataField={"jobTitle"} caption="직위(직책)" /> */}
      <Column dataField={"jobTitle"} caption="Position" />
      <Column
        dataField={"startDate"}
        // caption="입사일"
        caption="Employment Date"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column
        dataField={"endDate"}
        // caption="퇴사일"
        caption="Resignation Date"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column
        dataField={"ps"}
        caption="재직중"
        calculateCellValue={calculateCellValue}
      />
      {/* <Column dataField={"reasonL"} caption="퇴사사유"> */}
      <Column dataField={"reasonL"} caption="Reason for Resignation">
        <Lookup
          dataSource={reasonLListOfCareer}
          valueExpr="id"
          displayExpr={"name"}
        />
      </Column>
      <Column
        dataField={"otrReasonL"}
        // caption="기타 퇴사사유"
        caption="Other Reason for Resignation"
        visible={false}
      />
      <Column
        dataField={"jobDescr"}
        // caption="담당업무"
        caption="Responsibilities"
        encodeHtml={false}
        visible={false}
      />
      <Column
        dataField={"sa"}
        caption="연봉"
        dataType={"number"}
        format={"#,##0"}
      />
      <Column
        dataField={"saUnit"}
        caption="연봉단위"
        // calculateCellValue={calculateSaUnitCellValue}
      >
        <Lookup dataSource={saUnitList} valueExpr="id" displayExpr={"name"} />
      </Column>
      <Column
        dataField={"recogExp"}
        caption="인정경력여부"
        // calculateCellValue={calculateRecogExpCellValue}
      >
        <Lookup dataSource={recogExpList} valueExpr="id" displayExpr={"name"} />
      </Column>
    </DataGrid>
  );
}
